import { User } from 'oidc-client-ts';
import { oidcAuthority, oidcClientId } from '@definitions';

export function getUser() {
  const key = `oidc.user:${oidcAuthority}:${oidcClientId}`;
  const oidcStorage = sessionStorage.getItem(key);
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}
